function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { logger, getEventDescription, stringMatchesSomePattern } from '@sentry/utils'; // "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.

var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */

var InboundFilters = /*#__PURE__*/function () {
  function InboundFilters() {
    var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, InboundFilters);

    this._options = _options;

    InboundFilters.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */


  _createClass(InboundFilters, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = InboundFilters.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      var eventProcess = function eventProcess(event) {
        var hub = getCurrentHub();

        if (hub) {
          var self = hub.getIntegration(InboundFilters);

          if (self) {
            var client = hub.getClient();
            var clientOptions = client ? client.getOptions() : {};

            var options = _mergeOptions(self._options, clientOptions);

            return _shouldDropEvent(event, options) ? null : event;
          }
        }

        return event;
      };

      eventProcess.id = this.name;
      addGlobalEventProcessor(eventProcess);
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'InboundFilters';
    }
  }]);

  return InboundFilters;
}();

InboundFilters.__initStatic();
/** JSDoc */


function _mergeOptions() {
  var internalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var clientOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    allowUrls: [].concat(_toConsumableArray(internalOptions.allowUrls || []), _toConsumableArray(clientOptions.allowUrls || [])),
    denyUrls: [].concat(_toConsumableArray(internalOptions.denyUrls || []), _toConsumableArray(clientOptions.denyUrls || [])),
    ignoreErrors: [].concat(_toConsumableArray(internalOptions.ignoreErrors || []), _toConsumableArray(clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
    ignoreTransactions: [].concat(_toConsumableArray(internalOptions.ignoreTransactions || []), _toConsumableArray(clientOptions.ignoreTransactions || [])),
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
  };
}
/** JSDoc */


function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat(getEventDescription(event)));
    return true;
  }

  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat(getEventDescription(event)));
    return true;
  }

  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat(getEventDescription(event)));
    return true;
  }

  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat(getEventDescription(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
    return true;
  }

  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat(getEventDescription(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
    return true;
  }

  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(function (message) {
    return stringMatchesSomePattern(message, ignoreErrors);
  });
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  var name = event.transaction;
  return name ? stringMatchesSomePattern(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }

  var url = _getEventFilterUrl(event);

  return !url ? false : stringMatchesSomePattern(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }

  var url = _getEventFilterUrl(event);

  return !url ? true : stringMatchesSomePattern(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }

  if (event.exception) {
    try {
      var _ref = event.exception.values && event.exception.values[0] || {},
          _ref$type = _ref.type,
          type = _ref$type === void 0 ? '' : _ref$type,
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? '' : _ref$value;

      return ["".concat(value), "".concat(type, ": ").concat(value)];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error("Cannot extract message for event ".concat(getEventDescription(event)));
      return [];
    }
  }

  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {// ignore
  }

  return false;
}

function _getLastValidUrl() {
  var frames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  for (var i = frames.length - 1; i >= 0; i--) {
    var frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    var frames;

    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {// ignore
    }

    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error("Cannot extract url for event ".concat(getEventDescription(event)));
    return null;
  }
}

export { InboundFilters, _mergeOptions, _shouldDropEvent };